import React, { PureComponent } from "react";
import { currentLocale } from "../locale";
import "../style/recorder.scss";
import {
	SET_INVALID,
	SET_VALID,
	SET_BACK_INVALID,
	SET_BACK_VALID,
	SIGNER_NAME_COLLECTED,
	PARTICIPANTS_COLLECTED,
	LINKED_PARTICIPANT_SELECTED,
	LINKED_PARTICIPANTS_COLLECTED,
	PARTICIPANTS_AND_SIGNER_COLLECTED
} from "../constants";
import {
	concat,
	compose,
	dropLast,
	equals,
	find,
	head,
	isEmpty,
	isNil,
	join,
	length,
	map,
	merge,
	not,
	or,
	pluck,
	prop,
	takeLast,
	replace,
	tail
} from "ramda";
import { connect } from "react-redux";
import { toast } from "bulma-toast";
import moment from "moment";
import { converter } from "../lib/converter";
// import { Notification, AccessDeniedNotification } from "../components/modal";

const OT = require("@opentok/client");

class VideoSignature extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			recordingStatus: "",
			recording: false,
			startDisabled: true,
			stopDisabled: true,
			loading: false,
			show: false,
			start: false,
			allSet: false,
			publisher: true,
			open: true
		};
	}
	componentDidUpdate(prevProps) {
		if (this.props.recording.status !== prevProps.recording.status) {
			this.handleStatusChange();
		}
	}
	handleStatusChange = () => {
		if (this.props.recording.status === 4) {
			setTimeout(() => this.setState({ start: true }), 2000);
		}
	};
	componentWillMount() {
		const { values } = this.props.formikProps;

		//Each of these pull the participants -- linked and not
		//First is linkedParticipants, ROLE 3, w/ Bday
		if (not(this.props.skippedBackwards)) {
			// this is checking if they jumped backwards and did not change participantsInfo
			// console.log("***not(this.props.stepper.skippedBackwards)!!!***");
			if (
				this.props.signingInfo.role === 3 &&
				this.props.linkedPath &&
				this.props.waiver.birthday
			) {
				let linkedSingleParticipantBirthday = merge(
					head(this.props.pathParticipants.linkedParticipant),
					{
						participantBirthday: moment(values.birthday).format("YYYY-MM-DD")
					}
				);

				let linkedSingleParticipantName = pluck(
					`participantName`,
					this.props.pathParticipants.linkedParticipant
				);

				this.props.dispatch({
					type: LINKED_PARTICIPANTS_COLLECTED,
					payload: {
						name: linkedSingleParticipantName.join(),
						participants: concat(
							[linkedSingleParticipantBirthday],
							values.linkedParticipants
						)
					}
				});
				////if all participants were pulled from linkedParticipants
			} else if (
				this.props.signingInfo.role === 3 &&
				this.props.linkedPath &&
				equals(
					length(this.props.pathParticipants.linkedParticipants),
					length(this.props.formikProps.values.linkedParticipants) +
					length(this.props.pathParticipants.linkedParticipant)
				)
			) {
				this.props.dispatch({
					type: PARTICIPANTS_COLLECTED,
					payload: {
						participants: this.props.pathParticipants.linkedParticipants
					}
				});
				///linkedParticipants URL, but no linkedParticipants were selected
			} else if (
				this.props.signingInfo.role === 3 &&
				this.props.linkedPath &&
				isEmpty(this.props.pathParticipants.linkedParticipants) &&
				isEmpty(this.props.pathParticipants.linkedParticipant)
			) {
				this.props.dispatch({
					type: PARTICIPANTS_AND_SIGNER_COLLECTED, //PARTICIPANTS_COLLECTED,
					payload: {
						name: values.name,
						participants: concat(
							values.linkedParticipant,
							values.linkedParticipants
						)
					}
				});
				//////FIRST PARTICIPANT IS NOT LINKED\\\\
			} else if (
				this.props.signingInfo.role === 3 &&
				this.props.linkedPath &&
				!isEmpty(
					pluck(
						"participantName",
						this.props.pathParticipants.linkedParticipant
					)
				) &&
				!isEmpty(head(pluck("participantName", values.linkedParticipant)))
			) {
				this.props.dispatch({
					type: PARTICIPANTS_AND_SIGNER_COLLECTED,
					payload: {
						name: values.name,
						participants: concat(
							values.linkedParticipant,
							values.linkedParticipants
						)
					}
				});
				///if signedBYName was a linkedParticipant && others were not linked
			} else if (
				this.props.signingInfo.role === 3 &&
				this.props.linkedPath &&
				!isEmpty(
					pluck(
						"participantName",
						this.props.pathParticipants.linkedParticipant
					)
				) &&
				isEmpty(head(pluck("participantName", values.linkedParticipant)))
			) {
				this.props.dispatch({
					type: PARTICIPANTS_AND_SIGNER_COLLECTED,
					payload: {
						name: values.name,
						participants: concat(
							this.props.pathParticipants.linkedParticipant,
							values.linkedParticipants
						)
					}
				});
				///ELSE ROLE 3
			} else if (this.props.signingInfo.role === 3) {
				this.props.dispatch({
					type: PARTICIPANTS_AND_SIGNER_COLLECTED, //PARTICIPANTS_COLLECTED2,
					payload: {
						name: values.name,
						participants: [
							{
								participantName: values.name,
								participantBirthday: values.birthday
							},
							...values.participants
						]
					}
				});
				//if linkedParticipants and Role=2 Bday && noBday
			} else if (this.props.linkedPath && this.props.signingInfo.role === 2) {
				this.props.dispatch({
					type: LINKED_PARTICIPANTS_COLLECTED,
					payload: {
						participants: values.linkedParticipants,
						name: values.signedByName
					}
				});
			} else if (this.props.signingInfo.role === 2) {
				this.props.dispatch({
					type: PARTICIPANTS_AND_SIGNER_COLLECTED, //PARTICIPANTS_COLLECTED,
					payload: { participants: values.participants, name: values.name }
				});
			} else if (
				///ROLE=1 && name was selected from dropdown
				this.props.signingInfo.role === 1 &&
				this.props.linkedPath &&
				!isNil(
					find(
						prop("participantName"),
						this.props.pathParticipants.linkedParticipant
					)
				)
			) {
				let linkedSingleParticipantName = pluck(
					`participantName`,
					this.props.pathParticipants.linkedParticipant
				);
				//w. Bday
				if (this.props.waiver.birthday) {
					let linkedSingleParticipantBirthday = merge(
						head(this.props.pathParticipants.linkedParticipant),
						{
							participantBirthday: moment(values.birthday).format("YYYY-MM-DD")
						}
					);
					this.props.dispatch({
						type: LINKED_PARTICIPANT_SELECTED,
						payload: {
							name: linkedSingleParticipantName.join(),
							participants: [linkedSingleParticipantBirthday]
						}
					});
				}
				this.props.dispatch({
					type: LINKED_PARTICIPANT_SELECTED,
					payload: {
						name: values.name,
						participants: this.props.pathParticipants.linkedParticipant
					}
				});
			}
		}

		////IF NO LINKEDPARTICIPANTS && ROLE === 1 || linkedParticipants && ROLE1, but not using linkedParticipant
		///&& not skippedBackwards
		if (
			or(
				!this.props.linkedPath && this.props.signingInfo.role === 1,
				this.props.signingInfo.role === 1 &&
				this.props.linkedPath &&
				isNil(
					find(
						prop("participantName"),
						this.props.pathParticipants.linkedParticipant
					)
				)
			) &&
			not(this.props.skippedBackwards)
		) {
			this.props.dispatch({
				type: SIGNER_NAME_COLLECTED,
				payload: {
					name: values.name,
					participants: [
						{
							participantName: values.name,
							participantBirthday: values.birthday
						}
					]
				}
			});
		}

		this.props.dispatch({ type: SET_INVALID, payload: false });
		this.props.dispatch({ type: SET_BACK_INVALID, payload: false });
		this.setState({ loading: true });

		this.props.requestOpentok().then(() => {
			const session = OT.initSession(
				this.props.opentok.apiKey,
				this.props.opentok.sessionId
			);

			// Connect to the session
			session.connect(this.props.opentok.token, conmectErr => {
				if (conmectErr) {
					this.props.handleError(conmectErr);
				} else {
					let publisher = OT.initPublisher(
						"publisher",
						{
							insertMode: "append",
							facingMode: "user",
							width: "100%",
							height: "100%"
						},
						intPublisherErr => {
							if (intPublisherErr) {
								//								if (error.name === "OT_USER_MEDIA_ACCESS_DENIED") {
								this.setState({ publisher: "Error" });
								//								}
							} else {
								session.publish(publisher, publishErr => {
									if (publishErr) {
										this.props.handleError(publishErr);
									} else {
										this.setState({ startDisabled: false, loading: false });
										this.props.dispatch({ type: SET_BACK_VALID, payload: true });
										if (!isEmpty(this.props.recording)) {
											this.props.dispatch({ type: SET_VALID, payload: true });
										} else {
											this.props.dispatch({ type: SET_INVALID, payload: true });
										}
									}
								});
							}
						}
					);
				}
			});
		});
		//.then(() => setTimeout(() => this.setState({ allSet: true }), 2000));
	}

	componentWillUnmount() {
		const session = OT.initSession(
			this.props.opentok.apiKey,
			this.props.opentok.sessionId
		);
		session.disconnect();
	}
	timerStop = () => {
		if (this.state.recordingStatus === "startArchive") {
			this.handleStopRecording();
			toast({
				message: `${currentLocale.timeoutAlert}`,
				type: "is-danger",
				pauseOnHover: true,
				duration: 4000,
				opacity: 1
			});
		}
	};

	timer = () => {
		setTimeout(this.timerStop, 30000);
	};

	handleStartRecording = status => {
		this.setState({
			show: true,
			startDisabled: true,
			recordingStatus: "startArchive",
			recording: true
		});
		this.props.startRecording().then(() => {
			this.setState({ stopDisabled: false });
			//if (this.props.recording.status )
			this.timer();
		});
	};

	handleStopRecording = status => {
		this.setState({
			show: false,
			recordingStatus: "stopArchive",
			stopDisabled: true,
			recording: true,
			start: false,
			loading: true
		});
		this.props.stopRecording().then(() => {
			this.props.dispatch({ type: SET_VALID, payload: true });
			this.setState({ startDisabled: false, loading: false });
		});

		clearTimeout(this.timerStop);
	};
	// handleCloseDenied = () => {
	//   if (this.state.allSet && !this.state.publisher.accessAllowed) {
	//     this.props.handleReset()
	//   } else {
	//     this.setState({ open: false })
	//   }
	// }
	render() {
		const { linkedPath } = this.props;

		const participants = !linkedPath //isNil(remainingPath)
			? map(
				participant => participant.participantName,
				this.props.formikProps.values.participants
			)
			: !isNil(this.props.linkedParticipants) &&
				!isEmpty(this.props.pathParticipants.linkedParticipant)
				? concat(
					map(
						participant => participant.participantName,
						this.props.pathParticipants.linkedParticipant
					),
					map(
						participant => participant.participantName,
						this.props.formikProps.values.linkedParticipants
					)
				)
				: !isNil(
					find(
						prop("participantName"),
						this.props.pathParticipants.linkedParticipants
					)
				) && this.props.signingInfo.role === 2
					? map(
						participant => participant.participantName,
						this.props.formikProps.values.linkedParticipants
					)
					: !isNil(this.props.linkedParticipants)
						? map(
							participant => participant.participantName,
							this.props.formikProps.values.linkedParticipants
						)
						: [];

		const participants2 = join(" and ", participants);

		const participants2Tail = join(" and ", tail(participants));

		const participants3 = concat(
			`${join(" and ", [
				join(", ", dropLast(1, participants), takeLast(1, participants))
			])}`,
			` and ${takeLast(1, participants)}`
		);

		const participants3Tail = concat(
			`${join(" and ", [
				join(
					", ",
					dropLast(1, tail(participants)),
					takeLast(1, tail(participants))
				)
			])}`,
			` and ${takeLast(1, tail(participants))}`
		);

		const participantSignStatement =
			isEmpty(this.props.formikProps.values.name) &&
				isEmpty(this.props.formikProps.values.signedByName)
				? replace(
					"{{-ParticipantName-}}",
					`${pluck(
						`participantName`,
						this.props.pathParticipants.linkedParticipant
					)}`,
					`${this.props.waiver.participantStatement}`
				)
				: isEmpty(this.props.formikProps.values.name)
					? replace(
						"{{-ParticipantName-}}",
						`${this.props.formikProps.values.signedByName}`,
						`${this.props.waiver.participantStatement}`
					)
					: replace(
						"{{-ParticipantName-}}",
						`${this.props.formikProps.values.name}`,
						`${this.props.waiver.participantStatement}`
					);

		////////////Participants\\\\\\\\\\\
		let signStatementG;
		if (
			length(this.props.formikProps.values.participants) === 1 &&
			isEmpty(this.props.formikProps.values.name)
		) {
			signStatementG = compose(
				replace("{{-ParticipantName-}}", participants),
				replace(
					"{{-SignedByName-}}",
					`${this.props.formikProps.values.signedByName}`
				)
			)(`${this.props.waiver.guardianStatement}`);
		} else if (length(this.props.formikProps.values.participants) === 1) {
			signStatementG = compose(
				replace("{{-ParticipantName-}}", participants2),
				replace("{{-SignedByName-}}", `${this.props.formikProps.values.name}`)
			)(`${this.props.waiver.guardianStatement}`);
		} else {
			signStatementG = compose(
				replace("{{-ParticipantName-}}", participants3),
				replace("{{-SignedByName-}}", `${this.props.formikProps.values.name}`)
			)(`${this.props.waiver.guardianStatement}`);
		}

		///////////////LINKEDPARTICIPANTS\\\\\\\\\\\\
		let linkedSignStatementG;
		const name = isEmpty(this.props.formikProps.values.name)
			? this.props.formikProps.values.signedByName
			: this.props.formikProps.values.name;

		if (length(this.props.formikProps.values.linkedParticipants) === 1) {
			linkedSignStatementG = compose(
				replace("{{-ParticipantName-}}", participants),
				replace("{{-SignedByName-}}", `${name}`)
			)(`${this.props.waiver.guardianStatement}`);
		} else if (length(this.props.formikProps.values.linkedParticipants) === 2) {
			linkedSignStatementG = compose(
				replace("{{-ParticipantName-}}", participants2),
				replace("{{-SignedByName-}}", `${name}`)
			)(`${this.props.waiver.guardianStatement}`);
		} else {
			linkedSignStatementG = compose(
				replace("{{-ParticipantName-}}", participants3),
				replace("{{-SignedByName-}}", `${name}`)
			)(`${this.props.waiver.guardianStatement}`);
		}

		let linkedSignStatementRole3;
		//if arrayLength of linkedParticipants and non-linked === 1
		if (
			equals(1, length(this.props.formikProps.values.linkedParticipants)) &&
			equals(1, length(participants))
		) {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", participants),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
		} else if (length(this.props.formikProps.values.linkedParticipants) === 1) {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", tail(participants)),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
		} else if (
			//else if arrayLength of Linked and non-Linked === 2
			equals(2, length(this.props.formikProps.values.linkedParticipants)) &&
			equals(2, length(participants))
		) {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", participants2),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
		} else if (
			length(this.props.formikProps.values.linkedParticipants) === 2 //< length(participants)
		) {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", participants2Tail),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
			//else if 3 and greater
		} else if (
			equals(
				length(this.props.formikProps.values.linkedParticipants),
				length(participants)
			)
		) {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", participants3),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
		} else {
			linkedSignStatementRole3 = compose(
				replace("{{-ParticipantName-}}", participants3Tail),
				replace("{{-SignedByName-}}", this.props.formikProps.values.name)
			)(`${this.props.waiver.guardianStatement}`);
		}
		const deviceCheck =
			typeof window.orientation !== "undefined" ||
			navigator.userAgent.indexOf("IEMobile") !== -1;
		let signStatement;
		if (this.props.signingInfo.role === 3 && !linkedPath) {
			signStatement = signStatementG;
		} else if (this.props.signingInfo.role === 3) {
			signStatement = linkedSignStatementRole3;
		} else if (this.props.signingInfo.role === 2 && !linkedPath) {
			signStatement = signStatementG;
		} else if (this.props.signingInfo.role === 2) {
			signStatement = linkedSignStatementG;
		} else {
			signStatement = participantSignStatement;
		}
		let classname;
		if (deviceCheck) {
			classname = "tile is-child is-widescreen";
		} else {
			classname = "tile is-parent";
		}
		let cardclass;
		if (deviceCheck) {
			cardclass = "message  is-primary";
		} else {
			cardclass = "card";
		}
		const errmessage = replace(
			"{{-Site-}}",
			window.location.origin,
			`${currentLocale.accessDenied}`
		);
		return (
			<div>
				{/* {this.state.allSet && !this.state.publisher.accessAllowed &&
          <AccessDeniedNotification open={this.state.open} handleClose={this.handleCloseDenied} />} */}

				<nav className="level">
					<div className="level-item ">
						<div className="notification">
							{equals(this.state.publisher, "Error") ? (
								<p className="denied">{errmessage}</p>
							) : (
								""
							)}
							<div className="content">
								<h1 className="subtitle">{currentLocale.recordInstructions}</h1>

								<ul className="u-list" type="disc">
									<li> {currentLocale.recordVideo1}</li>
									<li>{currentLocale.recordVideo2}</li>
									<li>{currentLocale.recordVideo3}</li>
									<li>{converter.convert(`${currentLocale.recordVideo4}`)}</li>
								</ul>
							</div>
						</div>
					</div>
				</nav>

				<div className="tile is-ancestor">
					<div className={classname}>
						<div className="tile is-child ">
							<div className="sign-statement has-text-centered">
								{this.state.show && this.props.recording.status !== 4 ? (
									<p className="waiting">{currentLocale.wait}</p>
								) : this.state.show &&
									this.props.recording.status === 4 &&
									this.state.start === false ? (
									<p className="starting">{currentLocale.startRecording}</p>
								) : (
									""
								)}
								<article id="recordingDialog" className={cardclass}>
									<React.Fragment>
										{typeof window.orientation !== "undefined" ||
											navigator.userAgent.indexOf("IEMobile") !== -1 ? (
											<p className="is-size-6">{signStatement}</p>
										) : (
											<div className="card-content">
												<div className="content">
													<p>{signStatement}</p>
												</div>
											</div>
										)}
									</React.Fragment>
									<footer className="card-footer">
										<div className="level card-footer-item">
											{this.state.loading ? (
												<button
													className="button-play is-loading"
													type="button"
													disabled
												>
													<i className="fas fa-circle" />&nbsp;
													{currentLocale.record}
												</button>
											) : (
												<button
													className="button-play"
													type="button"
													disabled={
														this.state.startDisabled === true ||
														this.props.fetching === true ||
														equals(this.state.publisher, "Error")
													}
													onClick={e =>
														this.handleStartRecording("startArchive")
													}
												>
													<i className="fas fa-circle" />&nbsp;<span>
														{currentLocale.record}</span>
												</button>
											)}
											{this.state.loading ? (
												<button
													className="button-stop is-loading"
													type="button"
													dis="true"
												>
													<i className="fas fa-square" />&nbsp;
													<span>{currentLocale.stop}</span>
												</button>
											) : (
												<button
													type="button"
													className="button-stop"
													disabled={this.state.stopDisabled === true}
													onClick={e => this.handleStopRecording("stopArchive")}
												>
													<i className="fas fa-square" />&nbsp;
													{currentLocale.stop}
												</button>
											)}
										</div>
									</footer>
								</article>
							</div>
						</div>
					</div>
					<div className="tile is-parent container box is-8">
						<article className="tile is-child ">
							<div className="image is-4by3">
								<div id="publisher" className="publisher" />
							</div>
						</article>
					</div>
				</div>
				<br />
				<br />
				<br />
			</div>
		);
	}
}

const mapStateToProps = state => ({
	opentok: state.opentok.data,
	requesting: state.opentok.requesting,
	recording: state.recording,
	linkedParticipants: state.pathParticipants.linkedParticipants,
	pathParticipants: state.pathParticipants,
	skippedBackwards: state.stepper.skippedBackwards,
	otError: state.opentok.error
});
const mapActionToProps = dispatch => ({
	dispatch
});
const connector = connect(
	mapStateToProps,
	mapActionToProps
);
export default connector(VideoSignature);
